import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { PainelIndices } from './IndicesPage';

/** O histórico do cobre sem sair da análise: fecha e a negociação continua onde estava. */
export default function IndicesModal({ aberto, aoFechar }: { aberto: boolean; aoFechar: () => void }) {
  return (
    <Dialog open={aberto} onOpenChange={(abrir) => !abrir && aoFechar()}>
      <DialogContent className="max-w-6xl p-lg" aria-describedby={undefined}>
        <PainelIndices agrupamentoInicial="diario" mesesInicial={3} Titulo={DialogTitle} emModal />
      </DialogContent>
    </Dialog>
  );
}
